import { IconBoxDevice } from "../../components/Icons/Icons";
import styles from "./PageProjectDetail.module.css";

export const AdministratorInfoTab = ({ fundData }) => {
  return (
    <div
      className="page-security-head"
      style={{
        padding: "5px 0px 0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="page-security-subtitle" style={{ display: "flex", alignItems: "center", margin: "15px 0" }}>
        <IconBoxDevice
          colorIcon="#1b4ec1"
          height="15px"
          width="15px"
        />
        <span style={{ marginLeft: "10px" }}>Sobre {fundData?.gestor || "el Gestor"}</span>
      </div>

      <div className="d-flex">
        <img
          src={fundData?.image || fundData?.imagen || "https://picsum.photos/200/150"}
          alt={fundData?.gestor || "Gestor"}
          height="150px"
          style={{ borderRadius: "8px", marginRight: "10px", objectFit: "cover", width: "200px" }}
        />
        <p
          style={{ textAlign: "left" }}
          className={`mr-5 ${styles.infoTecBoxText}`}
        >
          {fundData?.gestor || "Devise Capital"} es una sociedad gestora de fideicomisos de inversión
          con más de 15 años de experiencia en la gestión de activos
          inmobiliarios y proyectos de infraestructura. Su enfoque se basa en la
          creación de valor sostenible y la diversificación estratégica para
          garantizar rentabilidades consistentes a sus inversionistas.
        </p>
      </div>
    </div>
  );
};
